export const CardData = [
    {
    id: 1,
    title: "Asunción de Raúl Alfonsín.",
    description: "10 de diciembre de 1983.",
  },
  {
    id: 2,
    title: "Inicio del juicio a las Juntas Militares.",
    description: "Abril de 1985. La Sentencia se produce en diciembre.",
  },
  {
    id: 3,
    title: "Argentina se consagra bi Campeón del Mundial de Fútbol.",
    description: "Junio de 1986.",
  },
  {
    id: 4,
    title: "Ley de Divorcio Vincular.",
    description: "Junio de 1987.",
  },
  {
    id: 5,
    title: "Levantamientos militares.",
    description: "1987 - 1988.",
  },
  {
    id: 6,
    title: "Saqueos, con focos en diferentes ciudades.",
    description: "Mayo de 1989.",
  },
  {
    id: 7,
    title: "Primer traspaso presidencial en democracia.",
    description: "Junio de 1989.",
  },
  {
    id: 8,
    title: "Asesinato de María Soledad Morales en Catamarca.",
    description: "Septiembre de 1990.",
  },
  {
    id: 9,
    title: "Creación del Mercosur",
    description: "1991.",
  },
  {
    id: 10,
    title: "Inicio del Programa de convertibilidad económica.",
    description: "Abril de 1991.",
  },
  {
    id: 11,
    title: "Pacto de Olivos.",
    description: "Noviembre de 1993.",
  },
  {
    id: 12,
    title: "Atentado a la Amia.",
    description: "Julio de 1994.",
  },
  {
    id: 13,
    title: "Sanción de la Reforma Constitucional.",
    description: "Agosto de 1994.",
  },
  {
    id: 14,
    title:
      "Eliminación del Servicio Militar Obligatorio, tras el asesinato del soldado Carrasco.",
    description: "Agosto de 1994.",
  },
  {
    id: 15,
    title: "Surgimiento de la agrupación HIJOS.",
    description:
      "Abril de 1995.",
  },
  {
    id: 16,
    title: "Surgimiento del Movimiento Piquetero.",
    description:
      "Junio de 1996. Movilizaciones y puebladas de Cutral Có y Plaza Huincul.",
  },
  {
    id: 17,
    title: "Comienzo de la protesta docente denominada “Carpa Blanca”.",
    description: "Diciembre 1997. Culmina en diciembre de 1999. ",
  },
  {
    id: 18,
    title: "Crisis del 2001.",
    description: "Diciembre.",
  },
  {
    id: 19,
    title:
      "Fin de la Convertibilidad Económica y pesificación de los depósitos bancarios en moneda extranjera.",
    description: "Enero de 2002.",
  },
  {
    id: 20,
    title: "Derogación de las leyes de obediencia debida y punto final.",
    description: "Agosto 2003.",
  },
  {
    id: 21,
    title: "Incendio en la discoteca Cromañón.",
    description: "Diciembre de 2004.",
  },
  {
    id: 22,
    title: "4ta Cumbre de las Américas en Mar del Plata.",
    description: "Noviembre de 2005.",
  },
  {
    id: 23,
    title: "Desaparición de Jorge Julio Lopez.",
    description: "Septiembre de 2006",
  },
  {
    id: 24,
    title:
      "Paro y movilización de las entidades agropecuarias en protesta por el aumento de las denominadas “retenciones” a la exportación de granos.",
    description: "Marzo a julio del 2008.",
  },
  {
    id: 25,
    title: "Re-estatización de los fondos de jubilaciones y pensiones.",
    description: "Octubre de 2008.",
  },
  {
    id: 26,
    title: "Aprobación de la Ley de servicios de comunicación audiovisual.",
    description: "Octubre de 2009.",
  },
  {
    id: 27,
    title: "Decreto de aprobación de la Asignación universal por hijo (AUH).",
    description: "Octubre de 2009.",
  },
  {
    id: 28,
    title: "Festejos del Bicentenario de la Revolución de Mayo.",
    description: "Mayo del 2010.",
  },
  {
    id: 29,
    title: "Ley de Matrimonio Igualitario.",
    description: "Julio de 2010.",
  },
  {
    id: 30,
    title: "Protestas de la clase media urbana.",
    description: "Mayo de 2012 a agosto de 2013.",
  },
  {
    id: 31,
    title:
      "Lanzamiento del primer satélite de comunicaciones de Latinoamérica, ArSat-1, concretado por INVAP.",
    description: "Octubre de 2014.",
  },
  {
    id: 32,
    title: "Aparición sin vida del cuerpo de Franco Casco. Rosario.",
    description: "Noviembre de 2014.",
  },
  {
    id: 33,
    title: "Marcha “Ni una Menos”. Paro Internacional de Mujeres.",
    description: "Junio de 2015.",
  },
  {
    id: 34,
    title: "Entra en vigencia el nuevo Código Civil y Comercial.",
    description: "Agosto 2015.",
  },
  {
    id: 35,
    title:
      "Eliminación de los derechos de exportación (llamados “retenciones”) del trigo, maíz y otros productos regionales, y reducción para la soja.",
    description: "Diciembre de 2012.",
  },
  {
    id: 36,
    title: "Solicitud de préstamo al FMI por 55 mil millones de dólares.",
    description: "Mayo de 2018.",
  },
  {
    id: 37,
    title: "Se decreta el Aislamiento Social Preventivo y Obligatorio.",
    description: "Marzo 2020.",
  },
  {
    id: 38,
    title: "Aprobación de la Ley de Interrupción Voluntaria del Embarazo.",
    description: "Diciembre de 2020.",
  },
  {
    id: 39,
    title:
      "La Selección Argentina de fútbol masculino se consagra Tricampeón Mundial de Fútbol. ",
    description: "Diciembre de 2022.",
  },
  {
    id: 40,
    title: "Asunción de Javier Milei.",
    description: "Diciembre 2023.",
  },
];
